import { FC } from "react";
import { useNavigate } from "react-router";
import Button from "../../components/ui/Button";

const NotFound: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-300px)] bg-[#f7f9fc] px-4">
      {/* 404 Number */}
      <h1 className="!text-[120px] font-bold !tracking-[-2.4px] !text-[#282828] leading-none mb-8">
        404
      </h1>

      {/* Title */}
      <h2 className="text-[27px] font-bold tracking-[-0.54px] text-[#282828] mb-6">
        Такой страницы не существует
      </h2>

      {/* Description */}
      <p className="text-[20px] font-semibold tracking-[-0.4px] text-[#000000] text-center max-w-[609px] mb-12 leading-normal">
        Запрошенная страница недоступна. Но путь к нужным автозапчастям открыт — начните с главной страницы.
      </p>

      {/* Return Button */}
      <Button 
        onClick={() => navigate('/')}
        className="!text-[16px] !font-semibold !tracking-[-0.32px] !px-8 !py-4"
      >
        Вернуться на главную
      </Button>
    </div>
  );
};

export default NotFound;